export default __webpack_public_path__ + "static/media/audio.ae0c3b50.svg";